import { ApiCallState } from "../Utils";
import { User } from "../User/User.type";
import { StoreRequisitionFollowUp } from "../StoreRequisitionFollowUp/StoreRequisitionFollowUp.type";
import { Department } from "../Department/Department.type";
import { EquipmentList } from "../EquipmentList/EquipmentList.type";

export type StoreRequisition = {
  id: number;
  user_id: number;
  department_id: number;
  equipment_list_id:number;
  transfer_from:string;
  transfer_to:string;

  request_number: string;

  requisition_reason: string;
  // previous_pm_reading: string;
  // current_pm_reading: string;
  // pr_number: string;

  date: string;

  requested_by_id: number;

  checked_by_id: number;
  is_checked: boolean;
  checked_date: string;

  // verified_by_id: number;
  // is_verified: boolean;
  // verified_date: string;

  approved_by_id: number;
  is_approved: boolean;
  approved_date: string;

  user: User;

  department: Department;
  requested_by: User;
  checked_by: User;
  // verified_by: User;
  approved_by: User;
  equipment_list:EquipmentList;

  store_requisition_follow_ups: StoreRequisitionFollowUp[];
};

export type StoreRequisitionStateTypes = {
  fetchAll: ApiCallState<StoreRequisition[]>;
  fetchOne: ApiCallState<StoreRequisition | {}>;
};

export const StoreRequisitionActionTypes = {
  FETCH_ALL_STORE_REQUISITION: "FETCH_ALL_STORE_REQUISITION",
  FETCH_ALL_STORE_REQUISITION_RESET: "FETCH_ALL_STORE_REQUISITION_RESET",
  FETCH_ALL_STORE_REQUISITION_FAILURE: "FETCH_ALL_STORE_REQUISITION_FAILURE",
  FETCH_ALL_STORE_REQUISITION_SUCCESS: "FETCH_ALL_STORE_REQUISITION_SUCCESS",

  FETCH_ONE_STORE_REQUISITION: "FETCH_ONE_STORE_REQUISITION",
  FETCH_ONE_STORE_REQUISITION_RESET: "FETCH_ONE_STORE_REQUISITION_RESET",
  FETCH_ONE_STORE_REQUISITION_FAILURE: "FETCH_ONE_STORE_REQUISITION_FAILURE",
  FETCH_ONE_STORE_REQUISITION_SUCCESS: "FETCH_ONE_STORE_REQUISITION_SUCCESS",
};
